import {
  Button,
  Component,
  InputBox,
  styleForFullExpansion,
  theme,
  useSafeCallback,
  useSafeState,
  useUnmountRef
} from '@atomica.co/components';
import { UserId } from '@atomica.co/types';
import { builder, EMPTY, Name, SLASH, Text } from '@atomica.co/utils';
import { SaveUserTwitterURLRequest } from '@atomica.co/yosemal';
import { default as React } from 'react';
import styled from 'styled-components';
import { HEADER_HEIGHT } from '../../../../../constants/common-constants';
import UserRequest from '../../../../../requests/user-request';
import InputProfileHeader from '../../../account-header/InputProfileHeader';
import { EditProfileIndex } from '../EditProfile';

interface P {
  userId: UserId | undefined;
  twitterURL: Text | undefined;
  onSave(twitterURL: Text): void;
  goTo(index: EditProfileIndex): void;
}

const InputTwitterURL: React.FC<P> = React.memo(props => {
  const { userId, twitterURL: initTwitterURL = EMPTY, onSave, goTo } = props;
  const unmountRef = useUnmountRef();
  const [disabledSaveButton, setDisabledSaveButton] = useSafeState<boolean>(unmountRef, false);
  const [twitterURLToSave, setTwitterURLToSave] = useSafeState<Name>(unmountRef, initTwitterURL);

  const saveTwitterURL = useSafeCallback(async (): Promise<void> => {
    if (!userId) return;
    setDisabledSaveButton(true);

    const dirs = twitterURLToSave.split(SLASH);
    const twitterId = !!dirs[dirs.length - 1] ? dirs[dirs.length - 1] : dirs[dirs.length - 2];

    const request = builder<SaveUserTwitterURLRequest>().userId(userId).twitterURL(twitterId).build();
    await UserRequest.saveTwitterURL(request);

    onSave(twitterId);
  }, [setDisabledSaveButton, userId, twitterURLToSave, onSave]);

  return (
    <Component style={styleForFullExpansion} className='input-twitter-url'>
      <HeaderArea>
        <InputProfileHeader label='Twiiter / @以降' onClick={goTo} />
      </HeaderArea>

      <Body>
        <InputWrapper>
          <InputBox showCount shape='rect' text={twitterURLToSave} onChange={setTwitterURLToSave} />
        </InputWrapper>

        <ButtonArea>
          <Button type='primary' disabled={disabledSaveButton} onClick={saveTwitterURL}>
            <StyledLabel>保存</StyledLabel>
          </Button>
        </ButtonArea>
      </Body>
    </Component>
  );
});

export default InputTwitterURL;

const HeaderArea = styled.div`
  width: 100%;
  height: ${HEADER_HEIGHT}px;
`;

const Body = styled.div`
  width: 100%;
  height: calc(100% - 48px);
`;

const InputWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: ${theme.mixins.spacing * 4}px ${theme.mixins.spacing * 2}px;
`;

const ButtonArea = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
`;

const StyledLabel = styled.div`
  width: 80px;
  height: auto;
`;
